import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import Select from '../../../common/Select/Select';
import { editCustomer } from '../../../../services/customer/customerService';
import APIError from '../../../../services/APIError';
import CustomerContext from '../../../../context/customer-context';
import Customer from '../../../../models/Customer';
import styles from '../MifidRelatedData.module.css';

function RiskLevel() {
  const { t } = useTranslation();
  const customerCtx = useContext(CustomerContext);
  const [isEdit, setIsEdit] = useState(false);
  const [modifiedCustomer, setModifiedCustomer] = useState<Customer>(customerCtx.customer);

  useEffect(() => {
    setModifiedCustomer(customerCtx.customer);
  }, [customerCtx.customer]);

  const updateCustomer = (risk: string) => {
    setModifiedCustomer({
      ...modifiedCustomer,
      risk: risk === 'Select' ? undefined : risk,
    });
  };

  const handleCancelButton = () => {
    setIsEdit(false);
    setModifiedCustomer(customerCtx.customer);
  };

  const handleSaveButton = async () => {
    try {
      await editCustomer({ ...modifiedCustomer });
      customerCtx.setCustomer(modifiedCustomer);
      setIsEdit(false);
    } catch (err) {
      if (err instanceof APIError) {
        console.log(`Failed to save customer: ${err.errorBody}`);
      } else {
        console.log(err);
      }
    }
  };

  return (
    <>
      <div className={styles.buttonContainer}>
        {!isEdit && (
          <button
            type='button'
            className={styles.button}
            onClick={() => setIsEdit(true)}
          >
            {t('common.edit')}
          </button>
        )}
        {isEdit && (
          <div>
            <button
              type='button'
              className={styles.button}
              onClick={handleSaveButton}
            >
              {t('common.save')}
            </button>
            <button
              type='button'
              className={styles.button}
              onClick={handleCancelButton}
            >
              {t('common.cancel')}
            </button>
          </div>
        )}
      </div>
      <div className={classNames(styles.container, isEdit && styles.editContainer)}>
        <div>
          {!isEdit && (
            <>
              <div className={styles.label}>
                {t('customer.dashboard.mifid.riskLevel')}
              </div>
              <div>{customerCtx.customer.risk}</div>
            </>
          )}
          {isEdit && (
            <Select
              id='riskLevel'
              options={[
                { value: 'Select' },
                { value: 'LOW' },
                { value: 'MEDIUM' },
                { value: 'HIGH' },
                { value: 'REJECT' },
              ]}
              label={t('customer.dashboard.mifid.riskLevel')}
              required
              value={customerCtx.customer.risk}
              onUpdate={(value) => updateCustomer(value)}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default RiskLevel;
